import { defineStore } from 'pinia'

interface State {
  user: UserPreview,
  permissions: string[],
  notificationCount: number,
  loggingOut: boolean,
  loading: boolean,
  deviceToken: string | null,
}

export const useAuthStore = defineStore('Auth', {
  state: (): State => ({
    user: {} as UserPreview,
    permissions: [],
    notificationCount: 0,
    loggingOut: false,
    loading: false,
    deviceToken: null,
  }),
  getters: {
  },
  actions: {
    setUser (data: UserPreview) {
      this.user = data
    },
    setPermissions (permissions: string[]) {
      this.permissions = permissions
    },
    setNotificationCount (count: number) {
      this.notificationCount = count
    },
    setLoading (isLoading = true) {
      this.loading = isLoading
    },
    setDeviceToken (token: string) {
      this.deviceToken = token
    },
    can (permission: string) {
      if (this.user?.role?.toLowerCase() === 'superadmin') return true
      return (this.permissions || []).includes(permission)
    },
    logout () {
      window.location.href = '/login'
      this.loggingOut = true
      this.$reset()
    },
  },
})
